<template>
    <div class="row justify-content-between">
        <div class="col">
            <h5>{{ $t($route.name + '.batteryChartTitle') }}</h5>
        </div>
        <div class="col" style="padding-bottom: 10px;">
            <div class="row justify-content-end" style="padding-right: 50px;">
                <button class="btn btn-sm btn-dark" v-on:click="downloadDataset()">
                    {{ $t($route.name + '.downloadDataset') }}
                </button>
                <button class="btn btn-light btn-sm" v-on:click="resetChartZoom()">Reset zoom</button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col" v-if="ready">
            <LineChart :chart-data="dataset" :reset-zoom-event="resetZoomEvent" />
        </div>
    </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart.vue"
import createCSV from "@/parsers/csv.creator.js"

export default {
    name: "BatteryVoltageChart",
    components: {
        LineChart
    },
    props: {
        splitDataset: Object
    },
    data() {
        return {
            dataset: [],
            ready: false,
            resetZoomEvent: false,
        }
    },
    mounted() {
        this.flattenDataset()
        this.ready = true;
    },
    methods: {
        resetChartZoom() {
            this.resetZoomEvent = true;
            this.$nextTick(() => {
                this.resetZoomEvent = false;
            })
        },
        flattenDataset(){
            const data = []
            
            data.push([this.splitDataset.datetime.name, this.splitDataset.battery_voltage.name])
            for(let i=0; i < this.splitDataset.datetime.dataset.length; i++){
                data.push([this.splitDataset.datetime.dataset[i], this.splitDataset.battery_voltage.dataset[i]])
            }
            this.dataset = data;
            
        },
        downloadDataset(){
            createCSV(this.dataset, "BatteryVoltageDataset");
        }
    }
}

</script>